import React from "react";
import "./Admon.css";
import { useDispatch, useSelector } from "react-redux";

import { CreateUser } from "../../redux/userWep";

const Admon = () => {
  const dispatch = useDispatch();
  const userPortaf = useSelector((store) => store.userPort.loading);

  const [formLogin, setFormLogin] = React.useState({
    user: "",
    password: "",
    PermisoEdicion: "",
  });

  console.log(formLogin);
  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setFormLogin({ ...formLogin, [name]: value });
  };

  return (
    <div>
      <form action="" className="form-style box container container-fluid ">
        <h1> Module of Administration</h1>

        <h3>Create User</h3>
        <div class="mb-3">
          <label for="" class="form-label">
            Name User :
          </label>
          <input
            type="text"
            name="user"
            class="form-control"
            id=""
            onChange={handleChange}
            placeholder=" Enter please name user new"
          />

          <label for="" class="form-label">
            {" "}
            Create Password :
          </label>
          <input
            class="form-control"
            type="password"
            name="password"
            onChange={handleChange}
            placeholder="Enter please of password"
          />

          <label for="" class="mb-4 form-label">
            Permisos Edicion : __{" "}
          </label>

          <input
            class="mb-4   form-check-input"
            onChange={handleChange}
            name="PermisoEdicion"
            type="checkbox"
            value="1"
            id="flexCheckDefault"
          ></input>

          <br />

          <button
            class="mb-4 btn-primary"
            type="button"
            onClick={() => dispatch(CreateUser(formLogin))}
          >
            Create{" "}
          </button>
          <button class="mb-3 btn-danger" type="button">
            Cancelar{" "}
          </button>
        </div>
      </form>

      <hr />

      <h2> Create portafolio new</h2>
    </div>
  );
};

export default Admon;
